export function Contact() {
  return (
    <>
      <h1>Contact</h1>
      <p>This is the contact page, nothing to see here yet...</p>
    </>
  );
}
